import { createReducer } from 'reduxsauce';
import { produce } from 'immer';
import clone from 'ramda/src/clone';
import findIndex from 'ramda/src/findIndex';
import propEq from 'ramda/src/propEq';
import { CommunityTypes } from '~/actions';
import { removeStatus } from '~/services/util';

const initialState = {
    status: [],
    subStatus: [],
    departments: [],
    individualTopic: {},
    topicComments: [],
    recentBlogs: {},
    communityBlogs: [],
    permissions: [],
    uploaded: {},
    topics: {},
    allTopics: [],
    featuredCategories: [],
    featuredItems: [],
    featuredProducts: {},
    employers: [],
    blogs: {
        premium: {},
        community: {},
    },
};

const postcreateblogRequest = produce((draft, action) => {
    draft.status.push('pending-fcb');
});
const postcreateblogSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-fcb', draft.status);
});
const postcreateblogFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-fcb', draft.status);
});

const addforumtopicRequest = produce((draft, action) => {
    draft.status.push('pending-aft');
});
const addforumtopicSuccess = produce((draft, action) => {
    draft.forumRecentTopic = action.response.data;
    draft.status = removeStatus('pending-aft', draft.status);
});
const addforumtopicFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-aft', draft.status);
});

const getforumindividualtopicRequest = produce((draft, action) => {
    // draft.status.push('pending-cfd')
});
const getforumindividualtopicSuccess = produce((draft, action) => {
    draft.individualTopic = action.response;
    draft.status = removeStatus('pending-cfd', draft.status);
});
const getforumindividualtopicFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cfd', draft.status);
});

const addtopiccommentRequest = produce((draft, action) => {
    draft.status.push('pending-ctc');
});
const addtopiccommentSuccess = produce((draft, action) => {
    draft.topicComments = action.response;
    if (draft.topicComments?.comment[0]) {
        draft.individualTopic.topics.data[0].comments.push(draft.topicComments.comment[0]);
    }
    draft.status = removeStatus('pending-ctc', draft.status);
});
const addtopiccommentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ctc', draft.status);
});

const editforumtopicRequest = produce((draft, action) => {
    draft.status.push('pending-cef');
});
const editforumtopicSuccess = produce((draft, action) => {
    draft.forumRecentTopic = action.response.data;
    draft.status = removeStatus('pending-cef', draft.status);
});
const editforumtopicFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cef', draft.status);
});

const deleteforumtopicRequest = produce((draft, action) => {
    draft.status.push('pending-cdf');
});
const deleteforumtopicSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cdf', draft.status);
});
const deleteforumtopicFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cdf', draft.status);
});

const getcommunityblogRequest = produce((draft, action) => {});
const getcommunityblogSuccess = produce((draft, action) => {
    const { user_id } = action.response;
    const idx = findIndex(propEq('user_id', user_id), draft.communityBlogs);
    if (idx > -1) {
        draft.communityBlogs[idx] = {
            ...draft.communityBlogs[idx],
            ...action.response,
            entity: draft.communityBlogs[idx].entity,
        };
    } else {
        draft.communityBlogs.push(action.response);
    }
});
const getcommunityblogFailure = produce((draft, action) => {});

const getcommunityuserRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-ccu');
});
const getcommunityuserSuccess = produce((draft, action) => {
    const { user_id } = action.response;
    const idx = findIndex(propEq('user_id', user_id), draft.communityBlogs);
    if (idx > -1) {
        draft.communityBlogs[idx] = { ...draft.communityBlogs[idx], ...action.response };
    } else {
        draft.communityBlogs.push(action.response);
    }
    draft.status = removeStatus('pending-ccu', draft.status);
});
const getcommunityuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccu', draft.status);
});

const getblogsummaryRequest = produce((draft, action) => {
    draft.status.push('pending-cbs');
});
const getblogsummarySuccess = produce((draft, action) => {
    const { user_id } = action.response;
    const idx = findIndex(propEq('user_id', user_id), draft.communityBlogs);
    if (idx > -1) {
        draft.communityBlogs[idx] = { ...draft.communityBlogs[idx], ...action.response };
    } else {
        draft.communityBlogs.push(action.response);
    }
    draft.status = removeStatus('pending-cbs', draft.status);
});
const getblogsummaryFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cbs', draft.status);
});

const getblogdetailsRequest = produce((draft, action) => {
    draft.status.push('pending-cbd');
});
const getblogdetailsSuccess = produce((draft, action) => {
    const { user_id } = action.response;
    const idx = findIndex(propEq('user_id', user_id), draft.communityBlogs);
    if (idx > -1) {
        draft.communityBlogs[idx] = { ...draft.communityBlogs[idx], ...action.response };
    } else {
        draft.communityBlogs.push(action.response);
    }
    draft.status = removeStatus('pending-cbd', draft.status);
});
const getblogdetailsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cbd', draft.status);
});

const postcommunityuserRequest = produce((draft, action) => {
    draft.status.push('pending-cpu');
});
const postcommunityuserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cpu', draft.status);
});
const postcommunityuserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cpu', draft.status);
});

const postsaveusercontentRequest = produce((draft, action) => {
    draft.status.push('pending-csu');
});
const postsaveusercontentSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-csu', draft.status);
});
const postsaveusercontentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-csu', draft.status);
});

const postpasswordchangeRequest = produce((draft, action) => {
    draft.status.push('pending-cpp');
});
const postpasswordchangeSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cpp', draft.status);
});
const postpasswordchangeFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cpp', draft.status);
});

const postregisteruserRequest = produce((draft, action) => {
    draft.status.push('pending-cru');
});
const postregisteruserSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cru', draft.status);
});
const postregisteruserFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cru', draft.status);
});

const postunfollowRequest = produce((draft, action) => {
    draft.status.push('pending-cuc');
});
const postunfollowSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cuc', draft.status);
});
const postunfollowFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cuc', draft.status);
});

const postconnectionupdateRequest = produce((draft, action) => {
    draft.status.push('pending-cac');
});
const postconnectionupdateSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cac', draft.status);
});
const postconnectionupdateFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cac', draft.status);
});

const getcommunityconnectionsRequest = produce((draft, action) => {
    draft.status.push('pending-ccc');
});
const getcommunityconnectionsSuccess = produce((draft, action) => {
    const { userId, connections } = action.response;
    const idx = findIndex(propEq('user_id', userId), draft.communityBlogs);
    if (idx > -1) {
        draft.communityBlogs[idx] = { ...draft.communityBlogs[idx], connections };
    } else {
        draft.communityBlogs.push(action.response);
    }
    draft.status = removeStatus('pending-ccc', draft.status);
});
const getcommunityconnectionsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccc', draft.status);
});

const postcommunityconnectRequest = produce((draft, action) => {
    draft.status.push('pending-cpc');
});
const postcommunityconnectSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cpc', draft.status);
});
const postcommunityconnectFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cpc', draft.status);
});

const getuserpermissionsRequest = produce((draft, action) => {
    draft.status.push('pending-cup');
});
const getuserpermissionsSuccess = produce((draft, action) => {
    const { userId, permissions } = action.response;
    const idx = findIndex(propEq('user_id', userId), draft.permissions);
    if (idx > -1) {
        draft.permissions[idx] = { ...draft.permissions[idx], ...permissions, user_id: userId };
    } else {
        draft.permissions.push({ ...permissions, user_id: userId });
    }
    draft.status = removeStatus('pending-cup', draft.status);
});
const getuserpermissionsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cup', draft.status);
});

const gettopicsRequest = produce((draft, action) => {
    draft.subStatus.push('pending-forum');
});
const gettopicsSuccess = produce((draft, action) => {
    const { categoryId, response } = action;
    draft.topics[categoryId] = response;
    draft.subStatus = removeStatus('pending-forum', draft.subStatus);
});
const gettopicsFailure = produce((draft, action) => {
    draft.subStatus = removeStatus('pending-forum', draft.subStatus);
});

const getalldepartmentforumtopicsRequest = produce((draft, action) => {});
const getalldepartmentforumtopicsSuccess = produce((draft, action) => {
    draft.allTopics = action.response;
});
const getalldepartmentforumtopicsFailure = produce((draft, action) => {});

const getcomblogpostsRequest = produce((draft, action) => {
    // draft.status.push('pending-cbp')
});
const getcomblogpostsSuccess = produce((draft, action) => {
    const { response, target } = action;
    // draft.status = removeStatus('pending-cbp', draft.status)
    draft.recentBlogs = response;
    if (target) draft.blogs[target] = response;
});
const getcomblogpostsFailure = produce((draft, action) => {
    // draft.status = removeStatus('pending-cbp', draft.status)
});

const geteditfeatureditemsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-ceft');
    }
});
const geteditfeatureditemsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ceft', draft.status);
    draft.featuredItems = action.response;
});
const geteditfeatureditemsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ceft', draft.status);
});

const getfeatureditemsRequest = produce((draft, action) => {
    draft.status.push('pending-cft');
});
const getfeatureditemsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cft', draft.status);
    draft.featuredItems = action.response;
});
const getfeatureditemsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cft', draft.status);
});

const postsavefeatureditemRequest = produce((draft, action) => {
    draft.status.push('pending-cpsf');
});
const postsavefeatureditemSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cpsf', draft.status);
});
const postsavefeatureditemFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cpsf', draft.status);
});

const postarchivefeatureditemRequest = produce((draft, action) => {
    draft.status.push('pending-cpaf');
});
const postarchivefeatureditemSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cpaf', draft.status);
});
const postarchivefeatureditemFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cpaf', draft.status);
});

const getfeaturedcategoriesRequest = produce((draft, action) => {
    draft.subStatus.push('pending-featured');
});
const getfeaturedcategoriesSuccess = produce((draft, action) => {
    draft.subStatus = removeStatus('pending-featured', draft.subStatus);
    draft.featuredCategories = action.response;
});
const getfeaturedcategoriesFailure = produce((draft, action) => {
    draft.subStatus = removeStatus('pending-featured', draft.subStatus);
});

const getcategorysponsoredproductsRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) {
        draft.status.push('pending-ccp');
    }
});
const getcategorysponsoredproductsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ccp', draft.status);
    const { id, response } = action;
    draft.featuredProducts[id] = response;
});
const getcategorysponsoredproductsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccp', draft.status);
});

const postsavecommentRequest = produce((draft, action) => {
    draft.status.push('pending-csc');
});
const postsavecommentSuccess = produce((draft, action) => {
    const comment = action.response.comment?.[0];
    const idx = findIndex(propEq('id', comment.parent_id), draft.recentBlogs?.posts?.data || []);
    if (idx > -1) {
        draft.recentBlogs?.posts?.data[idx]?.comments?.push(comment);
    }
    draft.status = removeStatus('pending-csc', draft.status);
});
const postsavecommentFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-csc', draft.status);
});

const postcontentflagRequest = produce((draft, action) => {
    draft.status.push('pending-ccf');
});
const postcontentflagSuccess = produce((draft, action) => {
    const { contentId, flag, liked } = action.response;
    const blogs = draft.communityBlogs;
    for (let index = 0; index < blogs.length; index++) {
        const idx = findIndex(propEq('id', contentId), blogs[index].posts?.data || []);
        if (idx > -1) {
            if (flag === 'like') {
                draft.communityBlogs[index].posts.data[idx].stats.likes += 1;
                if (draft.communityBlogs[index].posts.data[idx].stats.liked) {
                    draft.communityBlogs[index].posts.data[idx].stats.liked[liked.user_id] = liked;
                } else {
                    const _liked = {};
                    _liked[liked.user_id] = liked;
                    draft.communityBlogs[index].posts.data[idx].stats.liked = _liked;
                }
            }
        }
    }
    draft.status = removeStatus('pending-ccf', draft.status);
});
const postcontentflagFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ccf', draft.status);
});

const addcontenteventRequest = produce((draft, action) => {
    const { loading = true } = action;
    if (loading) draft.status.push('pending-cce');
});
const addcontenteventSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cce', draft.status);
});
const addcontenteventFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cce', draft.status);
});

const featuredpostsRequest = produce((draft, action) => {
    draft.status.push('pending-cfp');
});
const featuredpostsSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-cfp', draft.status);
});
const featuredpostsFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-cfp', draft.status);
});

const getemployersearchRequest = produce((draft, action) => {
    draft.status.push('pending-ges');
});
const getemployersearchSuccess = produce((draft, action) => {
    draft.status = removeStatus('pending-ges', draft.status);
    draft.employers = action.response;
});
const getemployersearchFailure = produce((draft, action) => {
    draft.status = removeStatus('pending-ges', draft.status);
});

const resetRequest = produce((draft) => {
    draft.status = [];
});

const clearRequest = produce((draft) => (draft = initialState));

export const reducer = createReducer(initialState, {
    [CommunityTypes.ADDFORUMTOPIC_REQUEST]: addforumtopicRequest,
    [CommunityTypes.ADDFORUMTOPIC_SUCCESS]: addforumtopicSuccess,
    [CommunityTypes.ADDFORUMTOPIC_FAILURE]: addforumtopicFailure,

    [CommunityTypes.POSTCREATEBLOG_REQUEST]: postcreateblogRequest,
    [CommunityTypes.POSTCREATEBLOG_SUCCESS]: postcreateblogSuccess,
    [CommunityTypes.POSTCREATEBLOG_FAILURE]: postcreateblogFailure,

    [CommunityTypes.GETFORUMINDIVIDUALTOPIC_REQUEST]: getforumindividualtopicRequest,
    [CommunityTypes.GETFORUMINDIVIDUALTOPIC_SUCCESS]: getforumindividualtopicSuccess,
    [CommunityTypes.GETFORUMINDIVIDUALTOPIC_FAILURE]: getforumindividualtopicFailure,

    [CommunityTypes.ADDTOPICCOMMENT_REQUEST]: addtopiccommentRequest,
    [CommunityTypes.ADDTOPICCOMMENT_SUCCESS]: addtopiccommentSuccess,
    [CommunityTypes.ADDTOPICCOMMENT_FAILURE]: addtopiccommentFailure,

    [CommunityTypes.EDITFORUMTOPIC_REQUEST]: editforumtopicRequest,
    [CommunityTypes.EDITFORUMTOPIC_SUCCESS]: editforumtopicSuccess,
    [CommunityTypes.EDITFORUMTOPIC_FAILURE]: editforumtopicFailure,

    [CommunityTypes.DELETEFORUMTOPIC_REQUEST]: deleteforumtopicRequest,
    [CommunityTypes.DELETEFORUMTOPIC_SUCCESS]: deleteforumtopicSuccess,
    [CommunityTypes.DELETEFORUMTOPIC_FAILURE]: deleteforumtopicFailure,

    [CommunityTypes.GETCOMMUNITYBLOG_REQUEST]: getcommunityblogRequest,
    [CommunityTypes.GETCOMMUNITYBLOG_SUCCESS]: getcommunityblogSuccess,
    [CommunityTypes.GETCOMMUNITYBLOG_FAILURE]: getcommunityblogFailure,

    [CommunityTypes.GETBLOGSUMMARY_REQUEST]: getblogsummaryRequest,
    [CommunityTypes.GETBLOGSUMMARY_SUCCESS]: getblogsummarySuccess,
    [CommunityTypes.GETBLOGSUMMARY_FAILURE]: getblogsummaryFailure,

    [CommunityTypes.GETBLOGDETAILS_REQUEST]: getblogdetailsRequest,
    [CommunityTypes.GETBLOGDETAILS_SUCCESS]: getblogdetailsSuccess,
    [CommunityTypes.GETBLOGDETAILS_FAILURE]: getblogdetailsFailure,

    [CommunityTypes.GETCOMMUNITYUSER_REQUEST]: getcommunityuserRequest,
    [CommunityTypes.GETCOMMUNITYUSER_SUCCESS]: getcommunityuserSuccess,
    [CommunityTypes.GETCOMMUNITYUSER_FAILURE]: getcommunityuserFailure,

    [CommunityTypes.POSTCOMMUNITYUSER_REQUEST]: postcommunityuserRequest,
    [CommunityTypes.POSTCOMMUNITYUSER_SUCCESS]: postcommunityuserSuccess,
    [CommunityTypes.POSTCOMMUNITYUSER_FAILURE]: postcommunityuserFailure,

    [CommunityTypes.POSTSAVEUSERCONTENT_REQUEST]: postsaveusercontentRequest,
    [CommunityTypes.POSTSAVEUSERCONTENT_SUCCESS]: postsaveusercontentSuccess,
    [CommunityTypes.POSTSAVEUSERCONTENT_FAILURE]: postsaveusercontentFailure,

    [CommunityTypes.POSTPASSWORDCHANGE_REQUEST]: postpasswordchangeRequest,
    [CommunityTypes.POSTPASSWORDCHANGE_SUCCESS]: postpasswordchangeSuccess,
    [CommunityTypes.POSTPASSWORDCHANGE_FAILURE]: postpasswordchangeFailure,

    [CommunityTypes.POSTREGISTERUSER_REQUEST]: postregisteruserRequest,
    [CommunityTypes.POSTREGISTERUSER_SUCCESS]: postregisteruserSuccess,
    [CommunityTypes.POSTREGISTERUSER_FAILURE]: postregisteruserFailure,

    [CommunityTypes.POSTUNFOLLOW_REQUEST]: postunfollowRequest,
    [CommunityTypes.POSTUNFOLLOW_SUCCESS]: postunfollowSuccess,
    [CommunityTypes.POSTUNFOLLOW_FAILURE]: postunfollowFailure,

    [CommunityTypes.POSTCONNECTIONUPDATE_REQUEST]: postconnectionupdateRequest,
    [CommunityTypes.POSTCONNECTIONUPDATE_SUCCESS]: postconnectionupdateSuccess,
    [CommunityTypes.POSTCONNECTIONUPDATE_FAILURE]: postconnectionupdateFailure,

    [CommunityTypes.GETCOMMUNITYCONNECTIONS_REQUEST]: getcommunityconnectionsRequest,
    [CommunityTypes.GETCOMMUNITYCONNECTIONS_SUCCESS]: getcommunityconnectionsSuccess,
    [CommunityTypes.GETCOMMUNITYCONNECTIONS_FAILURE]: getcommunityconnectionsFailure,

    [CommunityTypes.POSTCOMMUNITYCONNECT_REQUEST]: postcommunityconnectRequest,
    [CommunityTypes.POSTCOMMUNITYCONNECT_SUCCESS]: postcommunityconnectSuccess,
    [CommunityTypes.POSTCOMMUNITYCONNECT_FAILURE]: postcommunityconnectFailure,

    [CommunityTypes.GETUSERPERMISSIONS_REQUEST]: getuserpermissionsRequest,
    [CommunityTypes.GETUSERPERMISSIONS_SUCCESS]: getuserpermissionsSuccess,
    [CommunityTypes.GETUSERPERMISSIONS_FAILURE]: getuserpermissionsFailure,

    [CommunityTypes.GETTOPICS_REQUEST]: gettopicsRequest,
    [CommunityTypes.GETTOPICS_SUCCESS]: gettopicsSuccess,
    [CommunityTypes.GETTOPICS_FAILURE]: gettopicsFailure,

    [CommunityTypes.GETALLDEPARTMENTFORUMTOPICS_REQUEST]: getalldepartmentforumtopicsRequest,
    [CommunityTypes.GETALLDEPARTMENTFORUMTOPICS_SUCCESS]: getalldepartmentforumtopicsSuccess,
    [CommunityTypes.GETALLDEPARTMENTFORUMTOPICS_FAILURE]: getalldepartmentforumtopicsFailure,

    [CommunityTypes.GETCOMBLOGPOSTS_REQUEST]: getcomblogpostsRequest,
    [CommunityTypes.GETCOMBLOGPOSTS_SUCCESS]: getcomblogpostsSuccess,
    [CommunityTypes.GETCOMBLOGPOSTS_FAILURE]: getcomblogpostsFailure,

    [CommunityTypes.GETEDITFEATUREDITEMS_REQUEST]: geteditfeatureditemsRequest,
    [CommunityTypes.GETEDITFEATUREDITEMS_SUCCESS]: geteditfeatureditemsSuccess,
    [CommunityTypes.GETEDITFEATUREDITEMS_FAILURE]: geteditfeatureditemsFailure,

    [CommunityTypes.GETFEATUREDITEMS_REQUEST]: getfeatureditemsRequest,
    [CommunityTypes.GETFEATUREDITEMS_SUCCESS]: getfeatureditemsSuccess,
    [CommunityTypes.GETFEATUREDITEMS_FAILURE]: getfeatureditemsFailure,

    [CommunityTypes.POSTSAVEFEATUREDITEM_REQUEST]: postsavefeatureditemRequest,
    [CommunityTypes.POSTSAVEFEATUREDITEM_SUCCESS]: postsavefeatureditemSuccess,
    [CommunityTypes.POSTSAVEFEATUREDITEM_FAILURE]: postsavefeatureditemFailure,

    [CommunityTypes.POSTARCHIVEFEATUREDITEM_REQUEST]: postarchivefeatureditemRequest,
    [CommunityTypes.POSTARCHIVEFEATUREDITEM_SUCCESS]: postarchivefeatureditemSuccess,
    [CommunityTypes.POSTARCHIVEFEATUREDITEM_FAILURE]: postarchivefeatureditemFailure,

    [CommunityTypes.GETFEATUREDCATEGORIES_REQUEST]: getfeaturedcategoriesRequest,
    [CommunityTypes.GETFEATUREDCATEGORIES_SUCCESS]: getfeaturedcategoriesSuccess,
    [CommunityTypes.GETFEATUREDCATEGORIES_FAILURE]: getfeaturedcategoriesFailure,

    [CommunityTypes.GETCATEGORYSPONSOREDPRODUCTS_REQUEST]: getcategorysponsoredproductsRequest,
    [CommunityTypes.GETCATEGORYSPONSOREDPRODUCTS_SUCCESS]: getcategorysponsoredproductsSuccess,
    [CommunityTypes.GETCATEGORYSPONSOREDPRODUCTS_FAILURE]: getcategorysponsoredproductsFailure,

    [CommunityTypes.POSTSAVECOMMENT_REQUEST]: postsavecommentRequest,
    [CommunityTypes.POSTSAVECOMMENT_SUCCESS]: postsavecommentSuccess,
    [CommunityTypes.POSTSAVECOMMENT_FAILURE]: postsavecommentFailure,

    [CommunityTypes.POSTCONTENTFLAG_REQUEST]: postcontentflagRequest,
    [CommunityTypes.POSTCONTENTFLAG_SUCCESS]: postcontentflagSuccess,
    [CommunityTypes.POSTCONTENTFLAG_FAILURE]: postcontentflagFailure,

    [CommunityTypes.ADDCONTENTEVENT_REQUEST]: addcontenteventRequest,
    [CommunityTypes.ADDCONTENTEVENT_SUCCESS]: addcontenteventSuccess,
    [CommunityTypes.ADDCONTENTEVENT_FAILURE]: addcontenteventFailure,

    [CommunityTypes.FEATUREDPOSTS_REQUEST]: featuredpostsRequest,
    [CommunityTypes.FEATUREDPOSTS_SUCCESS]: featuredpostsSuccess,
    [CommunityTypes.FEATUREDPOSTS_FAILURE]: featuredpostsFailure,

    [CommunityTypes.GETEMPLOYERSEARCH_REQUEST]: getemployersearchRequest,
    [CommunityTypes.GETEMPLOYERSEARCH_SUCCESS]: getemployersearchSuccess,
    [CommunityTypes.GETEMPLOYERSEARCH_FAILURE]: getemployersearchFailure,

    [CommunityTypes.RESET_REQUEST]: resetRequest,

    [CommunityTypes.CLEAR_REQUEST]: clearRequest,
});
